"use client"
import { useState } from "react";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import CommunicationField from "./communicationField"
import SocialMediaField from "./socialMediaField"


export default function CommunicationHeader({ informations }: any) {
  const { scrollY } = useScroll();
  const [isFixed, setIsFixed] = useState<boolean>(false)
  useMotionValueEvent(scrollY, "change", (scrollValue) => { // Tracks and checks the scroll value if its greater than 300 or not.
    if (scrollValue > 200) setIsFixed(true)
    if (scrollValue < 200) setIsFixed(false)
  })


  return (
    <>
      <div className="max-[400px]:hidden flex justify-between items-center py-2.5 bg-pink-bg text-white px-16 font-rubik">
        <CommunicationField informations={informations} />
        <SocialMediaField informations={informations} />
      </div>



      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 2 } }}
        style={{
          y: isFixed ? '0%' : '300%',
        }}
        className="flex justify-between items-center px-5 py-2.5 text-white font-rubik bg-pink-bg z-50 w-full fixed duration-500 bottom-0 min-[750px]:hidden"
      >
        <CommunicationField informations={informations} />
        <SocialMediaField informations={informations} />
      </motion.div>
    </>
  )
}